import { Component, Input, OnInit } from '@angular/core';
import { VehicleValuation, InvestmentDuration } from '@common/core/models';
import { EInvestmentLength } from '@common/enums';

@Component({
  selector: 'cci-vehicle-card',
  templateUrl: './vehicle-card.component.html',
  styleUrls: ['./vehicle-card.component.scss'],
})
export class VehicleCardComponent implements OnInit {
  @Input() vehicleValuation: VehicleValuation;
  @Input() showGallery = false;
  @Input() showSuggestedVehicleValuation = false;
  @Input() showVehicleValuations = false;
  @Input() editInvestmentDuration = false;
  @Input() showVehicleDetailsButton = false;

  eInvestmentLength = EInvestmentLength;

  investmentDuration: InvestmentDuration;
  constructor() {}

  ngOnInit(): void {
    this.investmentDuration = this.vehicleValuation.investmentDuration;
  }
}
